import { ArrowRight } from "lucide-react";
import { STEPS } from "@/data/content";
import { Reveal } from "./Reveal";

export const HowItWorks = () => (
  <section id="jak-to-dziala" data-testid="how-section" className="py-24 lg:py-32 px-5 sm:px-8">
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <p className="text-sm tracking-widest uppercase text-violet-deep font-600">Jak to działa</p>
        <h2 className="mt-4 font-display font-700 text-4xl sm:text-5xl tracking-tighter text-ink max-w-2xl">
          Trzy proste kroki do gotowego e-booka
        </h2>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 gap-6 md:gap-4 items-stretch">
        {STEPS.map((s, i) => (
          <Reveal key={i} delay={i * 0.12} className="relative">
            <div className="h-full rounded-[1.75rem] bg-white border border-ink/5 p-8 shadow-[0_8px_30px_rgb(0,0,0,0.03)]">
              <span className="font-display font-800 text-6xl text-violet-soft">{s.n}</span>
              <h3 className="mt-4 font-display font-600 text-2xl text-ink">{s.title}</h3>
              <p className="mt-2 text-ink/55 leading-relaxed">{s.body}</p>
            </div>
            {i < STEPS.length - 1 && (
              <div className="hidden md:grid absolute top-1/2 -right-3 z-10 place-items-center h-8 w-8 rounded-full bg-violet text-white -translate-y-1/2">
                <ArrowRight size={16} />
              </div>
            )}
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
